import { Button, Col, ConfigProvider, DatePicker, Flex, Row } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import enUS from 'antd/lib/locale/en_US';
import ptBR from 'antd/lib/locale/pt_BR';
import { useAuthContext } from "../../../../contexts/AuthContext";
import i18next from "i18next";
import Spinner from "../../Atomics/Spinner";
import { useTranslation } from "react-i18next";
import { TimelineLoadDiagram } from "../../Molecules/Registry/TimelineLoadDiagram";
import { PeakLoad } from "../../Molecules/Registry/PeakLoad";
import { ConsumptionVSProduction } from "../../Molecules/Registry/ConsumptionVSProduction";

export const RegistryDailyAnalysis = ({ }) => {
    const { t } = useTranslation();
    const { checkToken } = useAuthContext();
    const [showApplyDailyButton, setShowApplyDailyButton] = useState(true);
    const [startOfDay, setStartOfDay] = useState(null);
    const [endOfDay, setEndOfDay] = useState(null);
    const [previousPeriod, setPreviousPeriod] = useState(null);
    const [dailyDataToFilter, setDailyDataToFilter] = useState({
        "startDay": dayjs().tz('UTC').subtract(2, 'day').startOf('day').toDate(),
        "endDay": dayjs().tz('UTC').subtract(2, 'day').endOf('day').toDate(),
        'previousPeriod': dayjs().tz('UTC').subtract(30, 'day').startOf('day').toDate()
    });
    const [currenFilterDate, setCurrentFilterDate] = useState(dayjs().tz('UTC').subtract(2, 'days').format('DD MMM, YYYY'));

    useEffect(() => {
        if (!showApplyDailyButton) {
            setTimeout(() => {
                setShowApplyDailyButton(true);
            }, 4000);
        }
    }, [showApplyDailyButton])

    const handleDailyPickerChange = (date) => {
        if (!date) {
            return;
        }

        // Convert the date received to UTC and adjust to the start and end of the day
        let startDate = dayjs(date).utc().startOf('day');
        let endDate = dayjs(date).utc().endOf('day');
        let previousDate = startDate.clone().subtract(30, 'days').startOf('day');

        // Log to verify the dates
        // console.log('Start Date (UTC):', startDate.format('YYYY-MM-DDTHH:mm:ss[Z]'));
        // console.log('End Date (UTC):', endDate.format('YYYY-MM-DDTHH:mm:ss[Z]'));
        // console.log('Previous Date (UTC):', previousDate.format('YYYY-MM-DDTHH:mm:ss[Z]'));

        // Update the state with the correct dates
        setStartOfDay(startDate);
        setEndOfDay(endDate);
        setPreviousPeriod(previousDate);
    };

    const applyDailyFilters = () => {
        const data = {
            startDay: startOfDay?.$d,
            endDay: endOfDay?.$d,
            previousPeriod: previousPeriod?.$d
        };
        setCurrentFilterDate(dayjs(Date.parse(startOfDay)).format('DD MMM, YYYY'))
        checkToken();//Validate token
        setDailyDataToFilter(data);
        setShowApplyDailyButton(false);
    }

    return (
        <Flex className='ant-anchors-content' vertical="true">

            <Row gutter={[16, 16]} align='middle'>
                <Col span={3} offset={15}></Col>
                <Col span={4}>
                    {/* We are using ptBR cause in the librrary of Ant Design theres a bug on the portuguese language pt_PT */}
                    <ConfigProvider locale={i18next.resolvedLanguage === 'en' ? enUS : ptBR}>
                        <DatePicker className='full-width'
                            size='large'
                            onChange={handleDailyPickerChange}
                            placeholder={currenFilterDate}
                            format="DD MMM, YYYY"
                        />
                    </ConfigProvider>
                </Col>
                <Col span={2}>
                    {showApplyDailyButton ?
                        <Button disabled={startOfDay !== null && endOfDay !== null ? false : true} shape="round" className="ant-btn ant-btn-blue -medium" onClick={applyDailyFilters}>{t('apply')}</Button>
                        : <Spinner stroke="green" size='30px' />}
                </Col>
            </Row>
            <TimelineLoadDiagram dataToFilter={dailyDataToFilter} />

            <PeakLoad dataToFilter={dailyDataToFilter} />

            <ConsumptionVSProduction dataToFilter={dailyDataToFilter} />

        </Flex>
    );
};